import React, {useState, useEffect} from 'react';
import ReactModal from "react-modal";

import "./PDSAStudyTabOne.css";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {NextButton} from "../../../../../../common/button/next-button/NextButton";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";
import {ProcessMeasureGraph} from "./process-measure-graph/ProcessMeasureGraph";
import {powerBIBase, processMeasuresReportID} from "../../../../../../../config/PowerBiReportConfig";

export const PDSAStudyTabOne = ({
                                    PDSA,
                                    setPDSA,
                                    setCurrentScreen,
                                    context,
                                    setSpinnerText,
                                    navigateTo,
                                    setActiveTab,
                                    savePDSA,
                                    active,
                                    showToaster,
                                    toolTipsEnabled
                                }) => {

    ReactModal.setAppElement('#root');

    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    useEffect(() => {
        setActiveTab("study");
    }, []);

    const isButtonDisabled = () => {
        return !PDSA.analysis;
    }

    const handleViewReportClick = () => {
        window.open(powerBIBase + processMeasuresReportID + "/ReportSection");
    }

    const handleNextClick = () => {
        if (active) {
            savePDSA(() => {
                setCurrentScreen("PDSAActTabOne");
            })
        } else {
            setCurrentScreen("PDSAActTabOne");
        }
    }

    const handleBalancingMeasuresClick = () => {
        setModalContent(
            <div className="study-tab-modal-content-container">
                <div className={"header-container-c"}>
                    <label className={"modal-header-c"}>Balancing Measures</label>
                    {toolTipsEnabled &&
                    <ToolTip tooltipExternalReference={"pdsaBalancingMeasures123"}
                             context={context}
                             setSpinnerText={setSpinnerText} showToaster={showToaster}
                             fieldName={"Balancing Measures:"}/>}
                </div>
                <div className="input-container">
                    <input className="text-input"
                           disabled={!active || !context.editMode}
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   balancingMeasureOne: target.value
                               }));
                           }}
                           defaultValue={PDSA.balancingMeasureOne ? PDSA.balancingMeasureOne : null}/>
                </div>
                <div className="input-container">
                    <input className="text-input"
                           disabled={!active || !context.editMode}
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   balancingMeasureTwo: target.value
                               }));
                           }}
                           defaultValue={PDSA.balancingMeasureTwo ? PDSA.balancingMeasureTwo : null}/>
                </div>
                <div className="input-container">
                    <input className="text-input"
                           disabled={!active || !context.editMode}
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   balancingMeasureThree: target.value
                               }));
                           }}
                           defaultValue={PDSA.balancingMeasureThree ? PDSA.balancingMeasureThree : null}/>
                </div>
            </div>
        );
        setShowModal(true);
    }

    const handleAnalysisClick = () => {
        setModalContent(
            <div className="study-tab-modal-content-container">
                <div className="input-container">
                    <div>
                        <label>Observation:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaObservationm123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Observation:"}/>}
                    </div>
                    <textarea disabled={true}
                              defaultValue={PDSA.observation ? PDSA.observation : null}
                    />
                </div>
                <div className="input-container">
                    <div>
                        <label>Analysis:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaAnalysis123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Analysis:"}/>}
                    </div>
                    <textarea defaultValue={PDSA.analysis ? PDSA.analysis : null}
                              disabled={!active || !context.editMode}
                              onChange={({target}) => {
                                  setPDSA((prevState) => ({
                                      ...prevState,
                                      analysis: target.value
                                  }));
                              }}/>
                </div>
            </div>
        );
        setShowModal(true);
    }

    return (
        <div className="study-tab-one-container">
            <div className="study-tab-one-button-container">
                <StandardButton text="Balancing Measures" onClick={handleBalancingMeasuresClick}/>
                <StandardButton text="Observation Analysis" onClick={handleAnalysisClick} required={(!PDSA.analysis)}/>
            </div>
            <div className="study-tab-one-header-container">
                <p className="study-tab-one-graph-header-text">Process Measures</p>
                <div className="study-tab-one-powerbi-button-container">
                    <div className="problem-report-button-container">
                        <div className={"problem-report-button"} onClick={handleViewReportClick}>
                            Power BI
                        </div>
                    </div>
                </div>
            </div>
            <div className="study-tab-one-report-container">
                <ProcessMeasureGraph context={context} setSpinnerText={setSpinnerText} showToaster={showToaster}/>
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview" onClick={() => {
                    navigateTo("problemTree");
                }}/>
            </div>
            <div className="pdsa-navigation-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSADoTabTwo");
                }}/>
                <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
            </div>
            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                {modalContent}
                <div className="modal-button-container">
                    <StandardButton text="Done" onClick={() => {
                        setShowModal(false)
                    }}/>
                </div>
            </ReactModal>
        </div>
    );
}
